import React, { useState, useEffect, useContext, useRef } from 'react';
import { FormLayout, InlineError, LegacyStack } from '@shopify/polaris';
import ProductsList from './ProductsList'
import Login from './Login'
import ContactForm from '../../ContactForm'
import PasswordForm from '../../PasswordForm'
import { FormContext, FormProvider } from '@thinkwell/react.common'
import { Spinner, TextField, Form } from '@thinkwell/react.polaris'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { CustomerContext } from '../../contexts/Customer'

export default function FreeTrialForm(props) {
  const [submitError, setSubmitError] = useState()
  const form = useContext(FormContext)
  const shop_name = useContext(ShopContext)
  const host = useContext(HostContext)
  const [customer] = useContext(CustomerContext)

  const dataLogin = {
    skus: form.field('skus'),
    login: true
  }

  const dataNew = {
    skus: form.field('skus'),
    new_account: true
  }

  const onError = (submitError) => {
    setSubmitError(submitError)
  }

  return (<div id="free-trial-registration" className="row full-width">
    <div className="grid">
      <div className="grid__item full-up--one-full">
        <h2 className="page-title">Try our online courses for free for 14 days!</h2>
      </div>
      <ProductsList maxCourses={props.maxCourses} />
      <div id="free-trial" className="grid__item medium-up--one-half">
        {
          submitError ?
          (submitError == 'enrollment_already_exists' ?
            <InlineError message={(<div><span>You've already signed up for this Free Trial.</span><span> Click <a href="/account">here</a> to access your account.</span></div>)} /> :
            <InlineError message={submitError} />)
          : null
        }
        { customer ?
          <Login onError={setSubmitError} />
        : (<div>
          <div>Do you already have a Thinkwell account? Click Login below.</div>
          <div>&nbsp;</div>
          <div>
            <FormProvider data={dataLogin}><Form
              method="post"
              url={`https://${host}/accounts/free_trial?shop_name=${shop_name}`}
              submitText="Login"
              onError={setSubmitError}
            >
              <TextField
                label="Email / Username"
                name="username"
              />
              <PasswordForm />
            </Form></FormProvider>
          </div>
          <div>&nbsp;</div>
          <hr/>
          <div>&nbsp;</div>
          <div>If you don't have a Thinkwell account yet, create one below.</div>
          <div>&nbsp;</div>
          <FormProvider data={dataNew}><Form
            method="post"
            url={`https://${host}/accounts/free_trial?shop_name=${shop_name}`}
            submitText="Create"
            onError={setSubmitError}
          >
            <ContactForm required={['first_name', 'last_name']} />
            <PasswordForm />
          </Form></FormProvider>
        </div>)}
      </div>
      </div>
    </div>)
}
